module.exports = __webpack_public_path__ + "static/img/BB.5dfd8e9f.svg";